// import { Box, InputBase, Stack } from '@mui/material'
// import React from 'react'
// import SearchIcon from '@mui/icons-material/Search';
// import NewCustomButton from '@component/Buttons/NewCustomButton';

// const NewSearch = ({ value, onChange, onSearch,isVisibleBtn = false, width = '250px',placeHolder }) => {
//   return (
//      <Stack direction="row" spacing={1} alignItems="center" mt={2}>
//          <Box
//              display="flex"
//              alignItems="center"
//              border="1px solid #ccc"
//              borderRadius={1}
//              px={1}
//              width={width}
//              bgcolor="#fff"
//          >
//              <SearchIcon fontSize="small" />
//              <InputBase
//                  placeholder={placeHolder}
//                  value={value}
//                  onChange={onChange}
//                  sx={{ flex: 1, fontSize: 12, padding: '5px 5px' }}
//              />
//          </Box>
//          {isVisibleBtn &&
//              <NewCustomButton onClick={onSearch}>
//                  Search
//              </NewCustomButton>
//          }
//          </Stack>
//   )
// }

// export default NewSearch

import React from 'react';
import { Search } from 'lucide-react'; // Or use any icon lib you prefer
import { Button } from "@/components/ui/button";

const NewSearch = ({ value, onChange, onSearch, isVisibleBtn = false, width = '250px', placeHolder = 'Search..',height='35px' }) => {
  return (
    <div className="font-sans flex items-center space-x-2">
      <div
        className="flex items-center border border-card-border rounded-lg px-2  bg-primary-foreground"
        style={{ width,height }}
      >
        <Search className="w-4 h-4 text-gray-500" />
        <input
          type="text"
          placeholder={placeHolder}
          value={value}
          onChange={onChange}
          className="flex-1 text-sm px-1 py-1 focus:outline-none  bg-primary-foreground"
        />
      </div>
      {isVisibleBtn && (
        <Button
          onClick={onSearch}
          // className="bg-primary-foreground text-foreground hover:bg-primary-foreground/20"
        >
          Search
        </Button>
      )}
    </div>
  );
};

export default NewSearch;
